import japaneseMessages from '@bicstone/ra-language-japanese';
import aggregate from '../resources/aggregate';

export default {
	...japaneseMessages,
	system: {
		name: 'システムサンプル',
	},
	dashboard: {
		title: 'ダッシュボード',
		userManagement: 'ユーザー管理',
	},
	resources: {
		user: {
			"name": "ユーザー管理",
			"list": "ユーザー一覧",
			"edit": "ユーザー編集",
			"show": "ユーザー詳細",
			fields: {
				id: 'ID',
				name: '名前',
			},
		},
		aggregate: {
			"name": "集計管理",
			"list": "集計一覧",
			fields: {
				variety: '品種',
				market: '市場',
				quantity: '数量',
				price: '単価',
				amount: '金額',
			},
		},
		seedling: {
			"name": "花苗管理",
			"list": "花苗一覧",
			"create": "花苗登録",
			fields: {
				planting_date: '挿し日',
				variety: '品種',
				target_count: '目標本数',
				harvest_date: '採穂日',
				cutting_count: '挿し本数',
				yield_count: '出来本数',
			},
		},
	},
	profile: {
		title: 'プロフィール編集',
		fields: {
			id: 'ID',
			name: '名前',
			kana: 'カナ',
			loginid: 'ログインID',
			new_password: '新しいパスワード',
			role: '権限',
		}
	}
};